import {
  Autocomplete,
  Backdrop,
  Checkbox,
  CircularProgress,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import moment from "moment";
import React, { ChangeEvent, useEffect, useState } from "react";
import { Link, Redirect } from "react-router-dom";
import { linkStyle, noArrows, red } from "../../theme";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import {
  setMsg,
  selectMsg,
  setErrMsg,
  selectErrMsg,
  selectRegNum,
  selectClaimInfo,
  selectAccount,
} from "../../redux/UserSlice";
import { ping, startRegistration } from "../../redux/UserAPI";
import {
  IAccount,
  ICurrency,
  IErrors,
  IExpenseRequest,
  IFile,
  UserInfo,
} from "../../interfaces";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { FeatureIcon } from "../../utils/FeatureIcon";
import upload from "../../img/portal_icon_upload_upload.png";
import { FileUploader } from "../FileUploader/FileUploader";
import currencies from "../../currencies.json";
import { selectErrors } from "../../redux/FormsSlice";
import ExpenseConfirmation from "./ExpenseConfirmation";
import {
  selectFiles,
  selectIsLoading,
  setFiles,
} from "../FileUploader/FileUploaderSlice";
import { NumericFormat, NumericFormatProps } from "react-number-format";
import ClearIcon from "@mui/icons-material/Clear";

interface Errors {
  first_name: { error: boolean; err_msg: string | null };
  last_name: { error: boolean; err_msg: string | null };
  dob: { error: boolean; err_msg: string | null };
  email: { error: boolean; err_msg: string | null };
  regNum: { error: boolean; err_msg: string | null };
  terms: { error: { color: string }; err_msg: string | null };
  emailConfirm: { error: { color: string }; err_msg: string | null };
}

export function SubmitExpense(props: any) {
  const [errors, setErrors] = useState<Array<string>>([]);

  const [years, setYears] = useState<number[]>([]);
  const [confirmation, setConfirmation] = useState(false);
  const [day, setDay] = useState("");
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");

  const msg = useAppSelector(selectMsg);
  const err_msg = useAppSelector(selectErrMsg);
  const regNum = useAppSelector(selectRegNum);
  const isLoading = useAppSelector(selectIsLoading);
  const claimantInfo = useAppSelector(selectClaimInfo);
  const account = useAppSelector(selectAccount);
  const files = useAppSelector(selectFiles);

  const history = useHistory();
  const dispatch = useAppDispatch();

  useEffect(() => {
    const getAccount = async () => {
      if (!account) {
        const res: any = await dispatch(ping("a"));
        console.log(res);
        if (res.error) {
          history.push("/");
        }
      }
    };
    getAccount();
  }, [account]);

  interface CustomProps {
    onChange: (event: { target: { name: string; value: string } }) => void;
    name: string;
  }

  const initialState = {
    EAP_ID: 0,
    REG_NUMBER: regNum ? regNum : 0,
    GRANT_CURRENCY: "",
    REQUEST_DATE: null,
    REQUEST_CURRENCY: claimantInfo?.LOCAL_CURRENCY
      ? currencies.filter(
          (curr) => curr.code === claimantInfo?.LOCAL_CURRENCY!.slice(0, 3)
        )[0]
      : null,
    REQUEST_AMOUNT_IN_REQUEST_CURRENCY: "",
    REQUEST_AMOUNT_IN_GRANT_CURRENCY: 0,
    APPROVED_AMOUNT_IN_GRANT_CURRENCY: 0,
    GRANT_TYPE: "",
    COMMITTEE_APROVAL_DECISION: "",
    DECISION_DATE: null,
  };
  const [state, setState] = useState<IExpenseRequest>(initialState);
  const expenseTypes = [
    "Dental",
    "Food",
    "Housekeeping/Homecare",
    "Housing & Related Costs",
    "Medical",
    "Funeral",
  ];

  useEffect(() => {
    const years = [];

    for (
      let i = new Date().getFullYear() - 1;
      i <= new Date().getFullYear();
      i++
    ) {
      years.push(i);
    }
    setYears(years);
    if (msg) {
      dispatch(setMsg(null));
      return;
    }
  }, []);

  console.log(account);

  useEffect(() => {
    if (msg === "Upload Successful") {
      setState(initialState);
      setDay("");
      setMonth("");
      setYear("");
    }
    if (err_msg) {
      return;
    }
  }, [msg, err_msg]);

  const days = [];
  const months = [];

  for (let d: number = 0; d < 31; d++) {
    days.push(d + 1);
  }
  for (let m: number = -1; m < 11; m++) {
    months.push(m + 1);
  }

  const disableButton =
    !!!day ||
    !!!(month + 1) ||
    !!!year ||
    (state.REQUEST_AMOUNT_IN_REQUEST_CURRENCY &&
      parseFloat(state.REQUEST_AMOUNT_IN_REQUEST_CURRENCY) <= 0) ||
    !!!state.GRANT_TYPE ||
    !state.GRANT_CURRENCY ||
    !state.REQUEST_CURRENCY ||
    !files.length;

  const handleGoBack = () => {
    dispatch(setFiles([]));
    history.push("/user_page");
  };

  return (
    <Paper
      sx={{
        margin: "auto",
        marginTop: "11em",
        marginBottom: "7em",
        width: "50em",
      }}
    >
      <ExpenseConfirmation
        display={confirmation}
        setDisplay={setConfirmation}
      />
      <Backdrop
        sx={{
          zIndex: 8000,
          color: "#fff",
        }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
        spacing={2}
        sx={{ padding: "3em", py: "1em", paddingTop: 0 }}
      >
        <Grid item xs={12} style={{ paddingBottom: 0, margin: "0 auto" }}>
          <Typography variant="h5" align="center" sx={{ pd: 0 }}>
            Submit an Expense
          </Typography>
        </Grid>
        <Grid xs={8} item style={{ paddingTop: 0 }}>
          <hr
            style={{ height: "1px", background: "black", width: "100%" }}
          ></hr>
        </Grid>

        <Grid item xs={12} style={{ paddingBottom: 0, margin: "0 auto" }}>
          <Typography variant="h6" align="center" sx={{ padding: 0 }}>
            Date of Expense
          </Typography>
        </Grid>
        <Grid md={4} item style={{ paddingTop: 0 }}>
          <TextField
            fullWidth
            sx={{
              "& .MuiPaper-root": {
                "& .MuiPopover-paper ": {
                  "& .MuiMenu-paper": {
                    maxHeight: "10em",
                  },
                },
              },
            }}
            label={
              <Typography>
                Day of Expense{" "}
                <Typography color="red" component="span">
                  *
                </Typography>
              </Typography>
            }
            error={errors?.includes("doe")}
            type="number"
            value={day}
            select
            onChange={(e) => setDay(e.target.value)}
          >
            {days.map((d, i) => {
              return (
                <MenuItem value={d} key={i}>
                  {d}
                </MenuItem>
              );
            })}
          </TextField>
        </Grid>
        <Grid md={4} item style={{ paddingTop: 0 }}>
          <TextField
            type="number"
            error={errors.includes("doe")}
            fullWidth
            select
            onChange={(e) => setMonth(e.target.value)}
            label={
              <Typography>
                Month of Expense{" "}
                <Typography color="red" component="span">
                  *
                </Typography>
              </Typography>
            }
            value={month}
          >
            {months.map((m, i) => {
              return (
                <MenuItem value={m} key={i}>
                  {moment().month(m).format("MMMM")}
                </MenuItem>
              );
            })}
          </TextField>
        </Grid>

        <Grid md={4} item style={{ paddingTop: 0 }}>
          <TextField
            fullWidth
            error={errors.includes("doe")}
            type="number"
            select
            value={year}
            onChange={(e) => setYear(e.target.value)}
            label={
              <Typography>
                Year of Expense{" "}
                <Typography color="red" component="span">
                  *
                </Typography>
              </Typography>
            }
          >
            {years.map((year, i) => {
              return (
                <MenuItem key={i} value={year}>
                  {year}
                </MenuItem>
              );
            })}
          </TextField>
        </Grid>

        <Grid xs={6} item sx={{ paddingTop: "7em" }}>
          <TextField
            sx={{
              " &.MuiSvgIcon-root-MuiSelect-icon": { right: 0 },
              "&:hover": { "& .MuiButtonBase-root": { visibility: "visible" } },
              "& .Mui-focused": {
                "& .MuiButtonBase-root": { visibility: "visible" },
              },
            }}
            select
            InputProps={{
              endAdornment: (
                <IconButton
                  sx={{ visibility: "hidden", marginRight: 2, padding: "4px" }}
                  size="medium"
                  onClick={() => setState({ ...state, GRANT_TYPE: "" })}
                >
                  <ClearIcon fontSize="small" />
                </IconButton>
              ),
            }}
            value={state.GRANT_TYPE}
            error={errors.includes("type")}
            onChange={(e) => {
              setState({ ...state, GRANT_TYPE: e.target.value });
            }}
            type="text"
            fullWidth
            label={
              <Typography>
                Type of Expense{" "}
                <Typography color="red" component="span">
                  *
                </Typography>
              </Typography>
            }
          >
            {expenseTypes.map((type, i) => {
              return (
                <MenuItem key={i} value={type}>
                  {type}
                </MenuItem>
              );
            })}
          </TextField>
        </Grid>

        <Grid xs={6} item style={{}}>
          <NumericFormat
            onValueChange={(values) => {
              const num = parseFloat(values.formattedValue);

              setState({
                ...state,
                REQUEST_AMOUNT_IN_REQUEST_CURRENCY: values.formattedValue,
              });
            }}
            customInput={TextField}
            fullWidth
            prefix={
              state.REQUEST_CURRENCY ? `${state.REQUEST_CURRENCY.symbol} ` : ""
            }
            label={
              <Typography>
                Expense Amount Requested{" "}
                <Typography color="red" component="span">
                  *
                </Typography>
              </Typography>
            }
            thousandSeparator
            value={state.REQUEST_AMOUNT_IN_REQUEST_CURRENCY}
            inputMode="decimal"
          />
        </Grid>
        <Grid xs={6} item style={{}}>
          <Autocomplete
            options={currencies}
            clearOnBlur={true}
            getOptionLabel={(option) => (option.name ? option.name : "")}
            sx={{ maxHeight: "5em" }}
            onChange={(e, value) =>
              setState({ ...state, REQUEST_CURRENCY: value ? value : null })
            }
            autoHighlight
            isOptionEqualToValue={(option, value) =>
              value.name ? option.name === value.name : option.name === ""
            }
            value={state.REQUEST_CURRENCY}
            renderInput={(params) => (
              <TextField
                {...params}
                label={
                  <Typography>
                    Amount Currency{" "}
                    <Typography color="red" component="span">
                      *
                    </Typography>
                  </Typography>
                }
                error={errors?.includes("currency")}
                helperText={
                  errors?.includes("currency")
                    ? "Please select your local currency"
                    : ""
                }
              />
            )}
          />
        </Grid>
        <Grid xs={6} item style={{}}>
          <TextField
            sx={{
              " &.MuiSvgIcon-root-MuiSelect-icon": { right: 0 },
              "&:hover": { "& .MuiButtonBase-root": { visibility: "visible" } },
              "& .Mui-focused": {
                "& .MuiButtonBase-root": { visibility: "visible" },
              },
            }}
            value={state.GRANT_CURRENCY}
            error={errors.includes("reimbursementCurrency")}
            onChange={(e) =>
              setState({ ...state, GRANT_CURRENCY: e.target.value })
            }
            type="text"
            fullWidth
            select
            InputProps={{
              endAdornment: (
                <IconButton
                  sx={{ visibility: "hidden", marginRight: 2, padding: "4px" }}
                  size="medium"
                  onClick={() => setState({ ...state, GRANT_CURRENCY: "" })}
                >
                  <ClearIcon fontSize="small" />
                </IconButton>
              ),
            }}
            label={
              <Typography>
                Reimbursement Currency{" "}
                <Typography color="red" component="span">
                  *
                </Typography>
              </Typography>
            }
          >
            <MenuItem value={"EUR"} key={"EUR"}>
              EUR
            </MenuItem>
            <MenuItem value={"USD"} key={"USD"}>
              USD
            </MenuItem>
          </TextField>
        </Grid>
      </Grid>

      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
        spacing={2}
        style={{ padding: 20, paddingTop: 0 }}
      >
        <Grid item xs={3} sx={{ pd: 0 }}>
          <FileUploader
            fund={"EAP"}
            regNum={regNum ? regNum : 0}
            disableButton={disableButton}
            expense={{
              ...state,
              REQUEST_DATE: new Date(`${year}-${month + 1}-${day}`),
            }}
          ></FileUploader>
        </Grid>
        <Grid xs={12} item style={{}}>
          <Link style={linkStyle} to="/user_page" onClick={handleGoBack}>
            Go Back
          </Link>
        </Grid>
      </Grid>
    </Paper>
  );
}
